import * as React from 'react';

import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

const CustomCards = ({imgURL, title, total}) => {
return (
    <Box component={Card} sx={{
            width: "100%",
            height: { xs: '220px', xl: '280px' },
            backgroundColor: "#000A0A1",
            backdropFilter: 'blur(10px)',
            borderRadius: '10px',
            boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            transition: 'transform 0.3s ease-in-out',
            '&:hover': {
                transform: 'scale(0.85)',
            },
            cursor: "pointer",
            zIndex: 1
    }}>
<Box sx={{ height: {xs:"150px", xl: "190px"}, maxHeight: {xs: "150px", xl: "190px"} }}>  
    <img src={imgURL} alt="Contemplative Reptile" style={{ width: "100%", height: "100%", objectFit: "cover"}} />
</Box>

    <Box sx={{ }}>
<Typography variant='h6' textAlign='center' sx={{ color: "black", fontSize: "16px", fontWeight: "bold" }}>
    {title}
</Typography>
</Box>
 <Box sx={{ }}>
<Typography variant='h5' textAlign='center' sx={{ color: (theme)=>theme.palette.primary.dark, fontSize: "24px", fontWeight: "bold", pb: {xs:"0.3rem", xl:"1rem"} }}>
    {`${total}`}
</Typography>
</Box>
    </Box>
);
}

export default CustomCards;